import React, { useEffect, useRef, createElement } from 'react';
export function HeroSection() {
  const videoRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
    const embedScript = document.createElement('script');
    embedScript.src = 'https://fast.wistia.com/embed/4aptcbxcux.js';
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(embedScript);
    const style = document.createElement('style');
    style.textContent = "wistia-player[media-id='4aptcbxcux']:not(:defined) { background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/4aptcbxcux/swatch'); display: block; filter: blur(5px); padding-top:177.78%; }";
    document.head.appendChild(style);
    if (videoRef.current) {
      const player = document.createElement('wistia-player');
      player.setAttribute('media-id', '4aptcbxcux');
      player.setAttribute('aspect', '0.5625');
      videoRef.current.appendChild(player);
    }
    return () => {
      if (document.head.contains(playerScript)) document.head.removeChild(playerScript);
      if (document.head.contains(embedScript)) document.head.removeChild(embedScript);
      if (document.head.contains(style)) document.head.removeChild(style);
    };
  }, []);
  const scrollToForm = () => {
    if (window.fbq) {
      window.fbq('trackCustom', 'registro completado');
    }
    document.getElementById('formulario')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-[#000000] text-white py-16 md:py-24 px-4" data-id="element-70">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center gap-12" data-id="element-71">
        <div className="flex-1 space-y-8" data-id="element-72">
          <h1 className="md:text-5xl font-bold text-[28px]" data-id="element-73">
            Trabajas todo el día... pero no creces al nivel que podrías
          </h1>

          <p className="text-lg md:text-xl text-gray-300" data-id="element-74">
            Hay fugas que no estas viendo y que te están frenando.
          </p>

          <div className="w-full rounded-xl overflow-hidden shadow-2xl" data-id="element-75">
            <div ref={videoRef} data-id="element-76" />
          </div>

          <div className="space-y-3 pt-4" data-id="element-77">
            <p className="text-sm font-semibold uppercase tracking-wider text-gray-300" data-id="element-78">
              DESCARGA GRATIS EL MAPA DE FUGAS DE TIEMPO
            </p>
            <button onClick={scrollToForm} className="bg-[#D90B10] hover:bg-[#c00a0e] text-white font-bold py-4 px-8 rounded-lg text-lg transition-colors w-full md:w-auto shadow-lg" data-id="element-79">
              QUIERO VER MIS FUGAS
            </button>
          </div>
        </div>

        <div className="flex-1 w-full" data-id="element-80"></div>
      </div>
    </section>;
}